export default __webpack_public_path__ + "static/media/hero-section-arm.20a583a0.svg";